import { render, staticRenderFns } from "./BuyPassDetails.vue?vue&type=template&id=fa2ccd08&scoped=true&"
import script from "./BuyPassDetails.vue?vue&type=script&lang=js&"
export * from "./BuyPassDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuyPassDetails.vue?vue&type=style&index=0&id=fa2ccd08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2ccd08",
  null
  
)

export default component.exports